<template>
	<div class="c-render-video-to-storyboard">
		<header>
			<strong>
				{{ script.name }}
			</strong>
		</header>
		<div class="c-render-video-to-storyboard__grid">
			<section>
				<span> Scene type </span>
				<span> Description </span>
				<span> Details </span>
			</section>
			<section v-for="(stage, i) in script" :key="i">
				<span>
					{{ stage.type }}
				</span>
				<span>
					{{ stage.description }}
				</span>
				<span>
					<ul>
						<li v-for="(detail, i) in stage.details" :key="i">
							{{ detail }}
						</li>
					</ul>
				</span>
			</section>
		</div>
	</div>
</template>

<script>
export default {
	data: function () {
		return {};
	},

	props: {
		script: {},
	},

	computed: {
		results: function () {
			return [
				{
					name: 'va-gen-01',
					script: this.script,
				},
			];
		},
	},

	methods: {
		next: function () {
			this.$emit('next');
		},
	},
};
</script>

<style lang="scss">
.c-render-video-to-storyboard {
	margin-bottom: 1rem;
	padding: 0.5rem;

	header {
		padding: var(--margin-lg);
	}

	&__grid {
		font-size: var(--font-size-xxs);
		font-family: var(--font-family-monospace);
		font-weight: 500;

		section {
			display: grid;
			grid-template-columns: repeat(3, minmax(0, 1fr));
			padding: 0.25rem 0;
			border-bottom: var(--color-bg-3) solid 1px;

			span {
				display: inline-block;
				padding-right: 0.25rem;
			}

			ul {
				margin-top: 0;

				li {
					margin-bottom: 0.5rem;
				}
			}

			&:first-of-type {
				opacity: 0.8;
			}

			&:last-of-type {
				border-bottom: none;
			}

			&:not(:first-of-type) {
				span {
					&:first-of-type {
						color: var(--color-secondary);

						min-width: 0;
						white-space: normal;
					}
				}
			}
		}
	}
}
</style>
